import { render, staticRenderFns } from "./PacienteInternamientos.vue?vue&type=template&id=4404c5fe&"
import script from "./PacienteInternamientos.vue?vue&type=script&lang=js&"
export * from "./PacienteInternamientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports